<div class="p-grid p-nogutter p-align-center custom-card align-items-center mb-3" data-cy="daily-task-summary">
	<div *ngIf="loading" class="flex justify-content-center my-5">
		Loading...
	</div>

	<div *ngIf="!loading && summary">
		<div class="grid">
			<!-- Left Section -->
			<div class="col-6">
				<div class="p-col-6 p-text-left">
					<div class="mb-1 font-bold" style="color: red;">
						Financial Risk: {{ financialRisk }}
					</div>
					<div class="font-bold" style="color: orange;">
						Operations Risk: {{ operationsRisk }} items
					</div>
				</div>
			</div>

			<!-- Right Section -->
			<div class="col-6">
				<div class="p-col-6 p-text-right">
					<div class="mb-1">AI Tasks Run: {{ aiTasksRun }}</div>
					<div>Auto-Completed Tasks: {{ autoCompletedTasks }}</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="!loading && !summary" class="flex bg-white justify-content-center my-5 custom-card">
		<div class="bg-blue-50 p-3 text-center rounded text-gray-800">
			{{
				errorStatus === 403
					? 'No AI enabled tasks available'
					: 'No data available for the selected date range'
			}}
			<div class="pt-1">
				<a
					href="mailto:support@tyalls.com"
					*ngIf="errorStatus === 403"
					class="text-primary cursor-pointer ml-1"
				>
					To enable AI Tasks contact support&#64;tyalls.com
				</a>
			</div>
		</div>
	</div>

</div>
